import {domReady} from '@roots/sage/client';
import Swiper from 'swiper/bundle';
import Isotope from 'isotope-layout/dist/isotope.pkgd.min';
import imagesloaded from 'imagesloaded/imagesloaded.pkgd.min';
import PhotoSwipeLightbox from 'photoswipe/lightbox';
//import stickybits from 'stickybits';
//import Paroller from 'paroller.js/dist/jquery.paroller.js';
//import LocomotiveScroll from 'locomotive-scroll';
import Rellax from "rellax";
import 'waypoints/lib/noframework.waypoints.min.js';
import scrolltofixed from 'scrolltofixed/jquery-scrolltofixed';

/**
 * app.main
 */
const main = async (err) => {
  
  if (err) {
    // handle hmr errors
    console.error(err);
  }

  // application code start



    //const scroll = new LocomotiveScroll();
    //start locomotive
    //   const scroll = new LocomotiveScroll({
    //     el: document.querySelector('[data-scroll-container]'),
    //     smooth: true
    // });


    // var rellax = new Rellax('.graphic-holder-right', {
    //   speed: 5,
    //   center: false,
    //   wrapper: null,
    //   round: true,
    //   vertical: true,
    //   horizontal: false
    // });



    // var rellax = new Rellax('.rellax', {
    //   center: true
    // });


    // Look for .hamburger
    var hamburger = document.querySelector(".hamburger");
    // On click
    hamburger.addEventListener("click", function() {
      console.log("menu clicked"); 
      // Toggle class "is-active"
      hamburger.classList.toggle("is-active");
      // Do something else, like open/close menu
    });


    // sticky header
    jQuery(document).ready(function($){

        if($('.site-header.sticky-header').length) {
            var headerHeight = $('.site-header.sticky-header').outerHeight(); // get the header height
            $('main').css('padding-top', headerHeight); // match the height of the header with the mau
        }
        
        $(window).scroll(function() {
          if ($(window).width() > 1199) { // desktop only
            
            if ($(document).scrollTop() > 50) { // scroll this amount to trigger
              $('.site-header.sticky-header').addClass('shrink'); // add shrink when we are at the top
              setTimeout(function() { // run the same header height matching on scroll
                var headerHeight = $('.site-header.sticky-header').outerHeight(); // get the new shrink height
                $('main').css('padding-top', headerHeight); // change main padding with the new height
              }, 400);
            } else {
              $('.site-header.sticky-header').removeClass('shrink'); // remove shrink when we are at the top2
            }
          }
        });

    });


    // scroll-up-header
    jQuery(document).ready(function($){
        if ($(window).width() > 1199) { // desktop only

          if($('.site-header.scroll-up-header').length) {
            var prevScrollpos = window.pageYOffset;
            var headerDiv = document.querySelector(".scroll-up-header"); // Get the header element and it's position
            var headerBottom = headerDiv.offsetTop + headerDiv.offsetHeight;
            var headerHeight = $('.scroll-up-header').outerHeight(); // get the header height
            $('main').css('padding-top', headerHeight); // match the height of the header with the mau
          
            window.onscroll = function() {
              var currentScrollPos = window.pageYOffset;
              if (prevScrollpos <= currentScrollPos ){  // if scrolling down, let it scroll out of view as normal
                  headerDiv.classList.remove("fixedToTop");
                  //console.log('header height is' headerHeight);
                  headerDiv.style.top = "-" + headerHeight + "px";
              } else {  // otherwise if we're scrolling up, fix the nav to the top
                  headerDiv.classList.add("fixedToTop");
                  headerDiv.style.top = "0";
                  $('main').css('padding-top', headerHeight); // match the height of the header with the mau
              }
              prevScrollpos = currentScrollPos;
            }
          }

        };
    });

    jQuery(document).ready(function($){
      // disable search form until user query is added
      $('form.search-form > input').keyup(function() {
        var empty = false;
        $('form.search-form > input').each(function() {
            if ($(this).val() == '') {
                empty = true;
            }
        });
        if (empty) {
            $('.cs-search').attr('disabled', 'disabled');
        } else {
            $('.cs-search').removeAttr('disabled');
        }
      });
    });

    // init Swiper:
    const swiperbanner = new Swiper('.swiper-banner', {
      // Optional parameters
      loop: true,
      // If we need pagination
      pagination: {
        el: '.swiper-banner-pagination',
        clickable: true
      },
    });

    // init Swiper:
    const swiperbannersplit = new Swiper('.swiper-banner-split', {
      // Optional parameters
      loop: true,
      // If we need pagination
      pagination: {
        el: '.swiper-banner-split-pagination',
        clickable: true
      },
    });


    // paroller.js Parallax inits
    //jQuery('.parallax-item').paroller(); 


    // initialise tooltips
    const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]')
    const tooltipList = [...tooltipTriggerList].map(tooltipTriggerEl => new bootstrap.Tooltip(tooltipTriggerEl))

 
    // ScrollToFixed - for single career floating sidebar
    jQuery(document).ready(function($){
      //if ($(window).width() > 1199) { // desktop only
        $('.stickme').scrollToFixed({
          marginTop: $('.site-header').outerHeight() + 10,
          minWidth: 1200,
          limit: function() {
              var limit = $('#apply').offset().top - $('.stickme').outerHeight(true) - 30;
              return limit;
          },
          zIndex: 99,
        });
      //};
    });

    // $(document).ready(function(){
    //     $('.hero-cta-height').matchHeight();
    // });
    // $(window).resize(function() {
    //     $('.hero-cta-height').matchHeight();
    // });
  

    // init Swiper:
    const swiperposts = new Swiper('.swiper-posts', {
      // Optional parameters
      loop: false,
      spaceBetween: 30,
      breakpoints: {
        576: {
          slidesPerView: 1,
          spaceBetween: 30,
        },
        768: {
          slidesPerView: 2,
          spaceBetween: 30,
        },
        992: {
          slidesPerView: 2,
          spaceBetween: 30,
        },
        1200: {
          slidesPerView: 3,
          spaceBetween: 30,
        },
        1400: {
          slidesPerView: 4,
          spaceBetween: 30,
        },
      },
      // If we need pagination
      pagination: {
        el: '.swiper-posts-pagination',
        clickable: true
      },
    });

    // init Swiper:
    const swiperlogos = new Swiper('.swiper-logos', {
      // Optional parameters
      loop: false,
      autoplay: {
        delay: 4000,
      },
      breakpoints: {
        576: {
          slidesPerView: 2,
          spaceBetween: 20,
        },
        768: {
          slidesPerView: 4,
          spaceBetween: 20,
        },
        992: {
          slidesPerView: 7,
          spaceBetween: 30,
        },
      },
      // If we need pagination
      pagination: {
        el: '.swiper-logos-pagination',
        clickable: true
      },
    });


    // init Swiper:
    const swiperslidergallery = new Swiper('.swiper-slider-gallery', {
      // Optional parameters
      loop: true,
      slidesPerView: 1.4,
      spaceBetween: 20,
      centeredSlides: true,
      breakpoints: {
        576: {
          slidesPerView: 2.4,
          spaceBetween: 20,
        },
        768: {
          slidesPerView: 4.4,
          spaceBetween: 20,
        },
        992: {
          slidesPerView: 4.5,
          spaceBetween: 20,
        },
      },
      // If we need pagination
      pagination: {
        el: '.swiper-slider-gallery-pagination',
        clickable: true
      },
    });


    // init Swiper:
    const swipertestimonialsv1 = new Swiper('.swiper-testimonials-v1', {
      // Optional parameters
      loop: true,
      autoplay: {
         delay: 4000,
      },
      effect: 'fade',
      fadeEffect: {
        crossFade: true
      },
      // If we need pagination
      pagination: {
        el: '.swiper-testimonials-v1-pagination',
        clickable: true
      },
    });


    // init Swiper:
    const swipertestimonialsv2 = new Swiper('.swiper-testimonials-v2', {
      // Optional parameters
      loop: true,
      autoplay: {
         delay: 4000,
      },
      slidesPerView: 1,
      spaceBetween: 0,
      breakpoints: {
        576: {
          slidesPerView: 2,
          spaceBetween: 20,
        },
        768: {
          slidesPerView: 2,
          spaceBetween: 20,
        },
        992: {
          slidesPerView: 3,
          spaceBetween: 20,
        },
      },
      // If we need pagination
      pagination: {
        el: '.swiper-testimonials-v2-pagination',
        clickable: true
      },
    });


    // init Swiper:
    const swipertestimonialsv3 = new Swiper('.swiper-testimonials-v3', {
      // Optional parameters
      loop: true,
      autoplay: {
         delay: 4000,
      },
      // If we need pagination
      pagination: {
        el: '.swiper-testimonials-v3-pagination',
        clickable: true
      },
    });


    // init Swiper:
    const swipertestimonialsv4 = new Swiper('.swiper-testimonials-v4', {
      // Optional parameters
      loop: true,
      autoplay: {
         delay: 4000,
      },
      // If we need pagination
      pagination: {
        el: '.swiper-testimonials-v4-pagination',
        clickable: true
      },
    });

    // init Swiper:
    const sliderteam = new Swiper('.swiper-team', {
      // Optional parameters
      loop: false,
      autoplay: {
         delay: 4000,
      },
      slidesPerView: 5,
      spaceBetween: 0,
      breakpoints: {
        576: {
          slidesPerView: 2,
          spaceBetween: 20,
        },
        768: {
          slidesPerView: 3,
          spaceBetween: 20,
        },
        992: {
          slidesPerView: 5,
          spaceBetween: 20,
        },
      },
      // If we need pagination
      pagination: {
        el: '.swiper-team-pagination',
        clickable: true
      },
    });


    
    // isotope for galleries
    var imagesLoaded = require('imagesloaded');
    (function ($) {
        var $grid = $('.grid').imagesLoaded( function() {
          $('.grid').isotope({
            // options
            itemSelector: '.grid-item',
            layoutMode: 'masonry'
          });
        });
        // filter items on button click
        $('.filter-button-group').on( 'click', 'button', function() {
          var filterValue = $(this).attr('data-filter');
          $('.grid').isotope({ filter: filterValue });
          
          $('.filter-button-group button').removeClass("active");
          $(this).addClass("active");
        });
    })(jQuery);


    // initialise photoswipe gallery
    const lightbox = new PhotoSwipeLightbox({
      gallery: '.pswp-gallery',
      children: 'a',
      showHideAnimationType: 'zoom',
      pswpModule: () => import('photoswipe')
    });
    lightbox.init();



      // function for detecting a change in the page height.
      function onElementHeightChange(elm, callback) {
        var lastHeight = elm.clientHeight
        var newHeight;
        (function run() {
            newHeight = elm.clientHeight;      
            if (lastHeight !== newHeight) callback();
            lastHeight = newHeight;
            if (elm.onElementHeightChangeTimer) {
              clearTimeout(elm.onElementHeightChangeTimer); 
            }
            elm.onElementHeightChangeTimer = setTimeout(run, 200); // timeout allows animations to run and clear first
        })();
      }
      // detect a change in the page height and refresh AOS
      onElementHeightChange(document.body, function(){
        AOS.refresh();
      });



// Development Projects Isotope
(function ($) {

  var $container = $('#projects');
  var itemSelector = '.grid-item'; // you forgot to declare this earlier

  // Initial Isotope setup
  $container.isotope({
    percentPosition: true,
    itemSelector: itemSelector,
    masonry: {
      columnWidth: '.grid-sizer',
    }
  });

  // Only proceed when images are fully loaded
  $container.imagesLoaded(function () {

    // Now safe to run pagination + layout
    setPagination();
    goToPage(1);
    $container.isotope('layout');
  });

  var itemsPerPageDefault = 10;
  var itemsPerPage = defineItemsPerPage();
  var currentNumberPages = 1;
  var currentPage = 1;
  var currentFilter = '*';
  var filterAtribute = 'data-filter';
  var pageAtribute = 'data-page';
  var pagerClass = 'isotope-pager';

  function changeFilter(selector) {
    $container.isotope({
      filter: selector
    });
  }

  function getFilterSelector() {
    var selector = itemSelector;
    if (currentFilter != '*') {
      selector += `[${filterAtribute}~="${currentFilter}"]`;
    }
    return selector;
  }

  function goToPage(n) {
    currentPage = n;

    var selector = getFilterSelector();
    selector += `[${pageAtribute}="${currentPage}"]`;

    changeFilter(selector);
  }

  function defineItemsPerPage() {
    var pages = itemsPerPageDefault;
    return pages;
  }

  function setPagination() {

    var SettingsPagesOnItems = function () {
      var itemsLength = $container.children(itemSelector).length;
      var pages = Math.ceil(itemsLength / itemsPerPage);
      var item = 1;
      var page = 1;
      var selector = getFilterSelector();

      $container.children(selector).each(function () {
        if (item > itemsPerPage) {
          page++;
          item = 1;
        }
        $(this).attr(pageAtribute, page);
        item++;
      });

      currentNumberPages = page;
    }();

    var CreatePagers = function () {
      var $isotopePager = ($('.' + pagerClass).length == 0) ? $('<div class="' + pagerClass + '"></div>') : $('.' + pagerClass);
      $isotopePager.html('');

      for (var i = 0; i < currentNumberPages; i++) {
        var $pager = $('<a href="javascript:void(0);" class="pager" ' + pageAtribute + '="' + (i + 1) + '"></a>');
        $pager.html(i + 1);

        $pager.click(function () {
          var page = $(this).eq(0).attr(pageAtribute);
          goToPage(page);
        });

        $pager.appendTo($isotopePager);
      }

      $container.after($isotopePager);
    }();
  }

  // Filter button click
  $('.filters button').click(function () {
    var filter = $(this).attr(filterAtribute);
    currentFilter = filter;

    setPagination();
    goToPage(1);
  });

  // Handle window resize
  $(window).resize(function () {
    itemsPerPage = defineItemsPerPage();
    setPagination();
    goToPage(1);
  });

})(jQuery);

};


/**
 * Initialize
 *
 * @see https://webpack.js.org/api/hot-module-replacement
 */
domReady(main);
import.meta.webpackHot?.accept(main);
